// Treat icon — dog bone, defaults to amber. Accepts optional color override.
type TreatIconProps = {
  size?: number;
  color?: string;
};

export function TreatIcon({ size = 28, color = "#F59E0B" }: TreatIconProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 640 640"
      aria-hidden="true"
      className="block"
    >
      <path
        d="M197.4 224C193.5 224 190.2 221.2 189.3 217.4C179.1 175.3 141.2 144 96 144C43 144 0 187 0 240C0 269.1 12.9 295.1 33.3 312.7C37.6 316.4 37.6 323.5 33.3 327.2C12.9 344.8 0 370.9 0 399.9C0 452.9 43 495.9 96 495.9C141.2 495.9 179.1 464.6 189.3 422.5C190.2 418.7 193.5 415.9 197.4 415.9L442.5 415.9C446.4 415.9 449.7 418.7 450.6 422.5C460.8 464.6 498.7 495.9 543.9 495.9C596.9 495.9 639.9 452.9 639.9 399.9C639.9 370.8 627 344.8 606.6 327.2C602.3 323.5 602.3 316.4 606.6 312.7C627 295.1 639.9 269 639.9 240C639.9 187 596.9 144 543.9 144C498.7 144 460.8 175.3 450.6 217.4C449.7 221.2 446.4 224 442.5 224L197.4 224z"
        fill={color}
      />
    </svg>
  );
}
